import { Box, CircularProgress } from '@mui/material';

function ScreenLoader() {
    return (
        <Box
            sx={{
                background: '#00000080',
                position: 'fixed',
                top: 0,
                left: 0,
                height: '100vh',
                width: '100vw',
                zIndex: 10000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
            data-testid="screen-loader"
        >
            <CircularProgress disableShrink />
        </Box>
    );
}

export default ScreenLoader;
